module.exports = __webpack_public_path__ + "img/icon-pick-01.4483f536.svg";